// This file is auto-generated by @hey-api/openapi-ts

import type { CancelablePromise } from './core/CancelablePromise';
import { OpenAPI } from './core/OpenAPI';
import { request as __request } from './core/request';
import type { AppCallbackData, AppCallbackResponse, GetPositionsv2Data, GetPositionsv2Response, GetWinv2Data, GetWinv2Response, GetCurrentPositionsResponse, GetPositionsData, GetPositionsResponse, GetPositionData, GetPositionResponse, DeletePositionData, DeletePositionResponse, UpdatePositionData, UpdatePositionResponse, CloseManuallyPositionData, CloseManuallyPositionResponse, GetWinData, GetWinResponse, GetProfitHistoryData, GetProfitHistoryResponse, GetPositionsTimelineData, GetPositionsTimelineResponse, GetTradersResponse, GetTraderTypesResponse, AddTraderData, AddTraderResponse, SimulateTraderData, SimulateTraderResponse, GetSimulationData, GetSimulationResponse, GetTraderData, GetTraderResponse, UpdateTraderData, UpdateTraderResponse, DeleteTraderData, DeleteTraderResponse, GetTraderProfitHistoryData, GetTraderProfitHistoryResponse, AddTraderPositionData, AddTraderPositionResponse, SellProfitableTraderData, SellProfitableTraderResponse, GetBrokersResponse, GetAccountsResponse, GetBrokerData, GetBrokerResponse, SetBrokerData, SetBrokerResponse, DeleteBrokerData, DeleteBrokerResponse, GetBrokerAccountsData, GetBrokerAccountsResponse, GetBrokerAssetsData, GetBrokerAssetsResponse, GetBrokerOptionsData, GetBrokerOptionsResponse, GetBrokerOptionsByInstrumentData, GetBrokerOptionsByInstrumentResponse, GetBrokerPositionsData, GetBrokerPositionsResponse, GetPricesData, GetPricesResponse, ListInstrumentsData, ListInstrumentsResponse, ImportInstrumentsData, ImportInstrumentsResponse, AddInstrumentData, AddInstrumentResponse, FindSimilarInstrumentsResponse, MergeInstrumentsData, MergeInstrumentsResponse, GetInstrumentsStatisticsResponse, SearchData, SearchResponse, SearchInstrumentData, SearchInstrumentResponse, GetInstrumentData, GetInstrumentResponse, ListMarketsResponse, ImportMarketsData, ImportMarketsResponse, AddMarketData, AddMarketResponse, ListSourcesResponse, GetSourcePriceData, GetSourcePriceResponse, GetOptionPriceData, GetOptionPriceResponse, HealthzLiveResponse, HealthzReadyResponse, GetBalancesHistoryData, GetBalancesHistoryResponse, GetDecisionsData, GetDecisionsResponse, AddApnsTokenData, AddApnsTokenResponse, TestNotificationApnsResponse, ListScreenersResponse, CreateOptionInterestScreeningRunData, CreateOptionInterestScreeningRunResponse, StreamScreeningRunData, StreamScreeningRunResponse, ListRunsResponse, GetRunStatusData, GetRunStatusResponse } from './types.gen';

export class CallbacksService {
    /**
     * OAuth callback
     * Handles OAuth callbacks from external sources
     * @param data The data for the request.
     * @param data.app Application/source name
     * @param data.code OAuth authorization code
     * @returns SuccessResponseDto Callback processed successfully
     * @throws ApiError
     */
    public static appCallback(data: AppCallbackData): CancelablePromise<AppCallbackResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/callbacks/{app}',
            path: {
                app: data.app
            },
            query: {
                code: data.code
            },
            errors: {
                404: 'Source not found'
            }
        });
    }
    
}

export class PositionsService {
    /**
     * Get positions v2
     * Advanced position filtering with date ranges, pagination, and multiple filter criteria
     * @param data The data for the request.
     * @param data.openedSince Filter positions opened since date (ISO 8601)
     * @param data.openedTo Filter positions opened until date (ISO 8601)
     * @param data.closedSince Filter positions closed since date (ISO 8601)
     * @param data.closedTo Filter positions closed until date (ISO 8601)
     * @param data.traderId Filter by trader ID
     * @param data.currency Filter by currency
     * @param data.type Filter by position status
     * @param data.take Number of records to return
     * @param data.skip Number of records to skip
     * @returns PositionsResponseDto Positions retrieved successfully
     * @throws ApiError
     */
    public static getPositionsv2(data: GetPositionsv2Data = {}): CancelablePromise<GetPositionsv2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/positions',
            query: {
                openedSince: data.openedSince,
                openedTo: data.openedTo,
                closedSince: data.closedSince,
                closedTo: data.closedTo,
                traderId: data.traderId,
                currency: data.currency,
                type: data.type,
                take: data.take,
                skip: data.skip
            }
        });
    }
    
    /**
     * Get win statistics v2
     * Calculate profit/loss statistics for closed positions by currency with optional date filtering
     * @param data The data for the request.
     * @param data.since Calculate wins since date (ISO 8601)
     * @param data.to Calculate wins until date (ISO 8601)
     * @param data.currencies Comma-separated currency codes to filter
     * @returns WinV2ResponseDto Win statistics calculated successfully
     * @throws ApiError
     */
    public static getWinv2(data: GetWinv2Data = {}): CancelablePromise<GetWinv2Response> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v2/positions/win',
            query: {
                since: data.since,
                to: data.to,
                currencies: data.currencies
            }
        });
    }
    
    /**
     * Get current open positions
     * Retrieves all currently open positions across all traders
     * @returns PositionsResponseDto Current open positions retrieved successfully
     * @throws ApiError
     */
    public static getCurrentPositions(): CancelablePromise<GetCurrentPositionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/positions/current'
        });
    }
    
    /**
     * Get positions with filters
     * Retrieves positions with optional filtering by date range, trader, currency, and status
     * @param data The data for the request.
     * @param data.since Start date filter (ISO format)
     * @param data.to End date filter (ISO format)
     * @param data.traderId Filter by trader ID
     * @param data.currency Filter by currency
     * @param data.type Filter by position status
     * @param data.take Number of results to return
     * @param data.skip Number of results to skip
     * @returns PositionsResponseDto Positions retrieved successfully
     * @throws ApiError
     */
    public static getPositions(data: GetPositionsData = {}): CancelablePromise<GetPositionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/positions',
            query: {
                since: data.since,
                to: data.to,
                traderId: data.traderId,
                currency: data.currency,
                type: data.type,
                take: data.take,
                skip: data.skip
            },
            errors: {
                400: 'Invalid status type'
            }
        });
    }
    
    /**
     * Get position by ID
     * Retrieves detailed information for a specific position
     * @param data The data for the request.
     * @param data.positionId Position ID
     * @returns PositionResponseDto Position details retrieved successfully
     * @throws ApiError
     */
    public static getPosition(data: GetPositionData): CancelablePromise<GetPositionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/positions/position/{positionId}',
            path: {
                positionId: data.positionId
            },
            errors: {
                404: 'Position not found'
            }
        });
    }
    
    /**
     * Delete position
     * Deletes an open position (only open positions can be deleted)
     * @param data The data for the request.
     * @param data.positionId Position ID
     * @returns DeletedResponseDto Position deleted successfully
     * @throws ApiError
     */
    public static deletePosition(data: DeletePositionData): CancelablePromise<DeletePositionResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/positions/position/{positionId}',
            path: {
                positionId: data.positionId
            },
            errors: {
                401: 'Closed position cannot be deleted',
                404: 'Position not found'
            }
        });
    }
    
    /**
     * Update position
     * Updates position parameters such as quantity
     * @param data The data for the request.
     * @param data.positionId Position ID
     * @param data.requestBody Position update payload
     * @returns PositionResponseDto Position updated successfully
     * @throws ApiError
     */
    public static updatePosition(data: UpdatePositionData): CancelablePromise<UpdatePositionResponse> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/v1/positions/position/{positionId}',
            path: {
                positionId: data.positionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'Position not found'
            }
        });
    }
    
    /**
     * Close position manually
     * Manually closes an open position at a specified price
     * @param data The data for the request.
     * @param data.positionId Position ID
     * @param data.requestBody Close price
     * @returns PositionResponseDto Position closed successfully
     * @throws ApiError
     */
    public static closeManuallyPosition(data: CloseManuallyPositionData): CancelablePromise<CloseManuallyPositionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/positions/position/{positionId}/closedManually',
            path: {
                positionId: data.positionId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Position already closed or invalid price',
                404: 'Position not found'
            }
        });
    }
    
    /**
     * Get profit/loss statistics
     * Calculates total profit/loss, min, max, and count for closed positions with optional filtering
     * @param data The data for the request.
     * @param data.since Start date filter (ISO format)
     * @param data.to End date filter (ISO format)
     * @param data.currencies Comma-separated list of currencies
     * @returns WinStatsDto Profit/loss statistics retrieved successfully
     * @throws ApiError
     */
    public static getWin(data: GetWinData = {}): CancelablePromise<GetWinResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/positions/win',
            query: {
                since: data.since,
                to: data.to,
                currencies: data.currencies
            }
        });
    }
    
    /**
     * Get profit history
     * Retrieves historical profit data aggregated by specified time granularity
     * @param data The data for the request.
     * @param data.granularity Time granularity
     * @returns ProfitHistoryResponseDto Historical profit data retrieved successfully
     * @throws ApiError
     */
    public static getProfitHistory(data: GetProfitHistoryData): CancelablePromise<GetProfitHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/positions/profitHistory',
            query: {
                granularity: data.granularity
            },
            errors: {
                401: 'Invalid granularity parameter'
            }
        });
    }
    
    /**
     * Get positions timeline
     * Retrieves a timeline view of position activities
     * @param data The data for the request.
     * @param data.take Number of results to return
     * @param data.skip Number of results to skip
     * @returns TimelineResponseDto Timeline retrieved successfully
     * @throws ApiError
     */
    public static getPositionsTimeline(data: GetPositionsTimelineData = {}): CancelablePromise<GetPositionsTimelineResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/positions/timeline',
            query: {
                take: data.take,
                skip: data.skip
            }
        });
    }
    
}

export class TradersService {
    /**
     * Get all traders
     * Retrieves a list of all active traders with their configuration and current positions
     * @returns TradersResponseDto List of traders retrieved successfully
     * @throws ApiError
     */
    public static getTraders(): CancelablePromise<GetTradersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/traders'
        });
    }
    
    /**
     * Get trader types
     * Retrieves all available trader algorithm types that can be instantiated
     * @returns TraderTypesResponseDto List of trader types retrieved successfully
     * @throws ApiError
     */
    public static getTraderTypes(): CancelablePromise<GetTraderTypesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/traders/types'
        });
    }
    
    /**
     * Add a new trader
     * Creates and adds a new trading algorithm instance with specified configuration
     * @param data The data for the request.
     * @param data.requestBody Trader configuration
     * @returns SuccessResponseDto Trader added successfully
     * @throws ApiError
     */
    public static addTrader(data: AddTraderData): CancelablePromise<AddTraderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/traders/trader',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Simulate trader
     * Runs a backtesting simulation of a trader strategy with historical data
     * @param data The data for the request.
     * @param data.requestBody Trader simulation configuration
     * @returns SimulationResponseDto Simulation started, returns simulation ID for tracking
     * @throws ApiError
     */
    public static simulateTrader(data: SimulateTraderData): CancelablePromise<SimulateTraderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/traders/simulations',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'Broker or trader type not found'
            }
        });
    }
    
    /**
     * Get simulation status
     * Retrieves the status and results of a running or completed simulation
     * @param data The data for the request.
     * @param data.simulationId Simulation ID
     * @returns SimulationStatusResponseDto Simulation status and results retrieved successfully
     * @throws ApiError
     */
    public static getSimulation(data: GetSimulationData): CancelablePromise<GetSimulationResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/traders/simulations/{simulationId}',
            path: {
                simulationId: data.simulationId
            }
        });
    }
    
    /**
     * Get trader by ID
     * Retrieves complete details for a specific trader including configuration and positions
     * @param data The data for the request.
     * @param data.traderId Trader ID
     * @returns TraderResponseDto Trader details retrieved successfully
     * @throws ApiError
     */
    public static getTrader(data: GetTraderData): CancelablePromise<GetTraderResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/traders/trader/{traderId}',
            path: {
                traderId: data.traderId
            },
            errors: {
                404: 'Trader not found'
            }
        });
    }
    
    /**
     * Update trader
     * Updates trader configuration parameters such as quantity, max positions, and strategy metadata
     * @param data The data for the request.
     * @param data.traderId Trader ID
     * @param data.requestBody Trader update payload
     * @returns UpdateTraderSuccessDto Trader updated successfully
     * @throws ApiError
     */
    public static updateTrader(data: UpdateTraderData): CancelablePromise<UpdateTraderResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/traders/trader/{traderId}',
            path: {
                traderId: data.traderId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                404: 'Trader not found'
            }
        });
    }
    
    /**
     * Delete trader
     * Removes a trader and stops its trading activity
     * @param data The data for the request.
     * @param data.traderId Trader ID
     * @returns SuccessResponseDto Trader deleted successfully
     * @throws ApiError
     */
    public static deleteTrader(data: DeleteTraderData): CancelablePromise<DeleteTraderResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/traders/trader/{traderId}',
            path: {
                traderId: data.traderId
            },
            errors: {
                404: 'Trader not found'
            }
        });
    }
    
    /**
     * Get trader profit history
     * Retrieves historical profit data for a specific trader aggregated by the specified time granularity
     * @param data The data for the request.
     * @param data.traderId Trader ID
     * @param data.granularity Time granularity
     * @returns ProfitHistoryResponseDto Trader profit history retrieved successfully
     * @throws ApiError
     */
    public static getTraderProfitHistory(data: GetTraderProfitHistoryData): CancelablePromise<GetTraderProfitHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/traders/trader/{traderId}/profitHistory',
            path: {
                traderId: data.traderId
            },
            query: {
                granularity: data.granularity
            },
            errors: {
                401: 'Invalid granularity parameter',
                404: 'Trader not found'
            }
        });
    }
    
    /**
     * Add position to trader
     * Manually adds a new position to a trader (marked as manually opened)
     * @param data The data for the request.
     * @param data.traderId Trader ID
     * @param data.requestBody Position details
     * @returns TraderResponseDto Position added successfully
     * @throws ApiError
     */
    public static addTraderPosition(data: AddTraderPositionData): CancelablePromise<AddTraderPositionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/traders/trader/{traderId}/position',
            path: {
                traderId: data.traderId
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                401: 'Invalid position parameters',
                404: 'Trader not found'
            }
        });
    }
    
    /**
     * Sell profitable positions
     * Closes all currently profitable positions held by the trader
     * @param data The data for the request.
     * @param data.traderId Trader ID
     * @returns SoldCountResponseDto Profitable positions sold successfully
     * @throws ApiError
     */
    public static sellProfitableTrader(data: SellProfitableTraderData): CancelablePromise<SellProfitableTraderResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/traders/trader/{traderId}/sellProfitable',
            path: {
                traderId: data.traderId
            },
            errors: {
                404: 'Trader not found'
            }
        });
    }
    
}

export class BrokersService {
    /**
     * Get all brokers
     * Retrieves a list of all configured brokers with their current state and metadata
     * @returns BrokersResponseDto List of brokers retrieved successfully
     * @throws ApiError
     */
    public static getBrokers(): CancelablePromise<GetBrokersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers'
        });
    }
    
    /**
     * Get all broker accounts
     * Retrieves account balances for all configured brokers including total and free balance per currency
     * @returns AccountsResponseDto Account balances retrieved successfully
     * @throws ApiError
     */
    public static getAccounts(): CancelablePromise<GetAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/accounts'
        });
    }
    
    /**
     * Get broker by name
     * Retrieves details for a specific broker including its state and metadata
     * @param data The data for the request.
     * @param data.broker Broker name
     * @returns BrokerResponseDto Broker details retrieved successfully
     * @throws ApiError
     */
    public static getBroker(data: GetBrokerData): CancelablePromise<GetBrokerResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/broker/{broker}',
            path: {
                broker: data.broker
            },
            errors: {
                404: 'Broker not found'
            }
        });
    }
    
    /**
     * Update broker state
     * Updates the operational state of a broker (start or pause)
     * @param data The data for the request.
     * @param data.broker Broker name
     * @param data.requestBody Broker update payload
     * @returns SuccessResponseDto Broker state updated successfully
     * @throws ApiError
     */
    public static setBroker(data: SetBrokerData): CancelablePromise<SetBrokerResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/brokers/broker/{broker}',
            path: {
                broker: data.broker
            },
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Invalid broker state',
                404: 'Broker not found'
            }
        });
    }
    
    /**
     * Delete broker
     * Deletes a broker configuration (only if broker is not currently active)
     * @param data The data for the request.
     * @param data.broker Broker name
     * @returns SuccessResponseDto Broker deleted successfully
     * @throws ApiError
     */
    public static deleteBroker(data: DeleteBrokerData): CancelablePromise<DeleteBrokerResponse> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/v1/brokers/broker/{broker}',
            path: {
                broker: data.broker
            },
            errors: {
                409: 'Broker is currently active and cannot be deleted'
            }
        });
    }
    
    /**
     * Get broker accounts
     * Retrieves all account balances for a specific broker
     * @param data The data for the request.
     * @param data.broker Broker name
     * @returns AccountsResponseDto Broker accounts retrieved successfully
     * @throws ApiError
     */
    public static getBrokerAccounts(data: GetBrokerAccountsData): CancelablePromise<GetBrokerAccountsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/broker/{broker}/accounts',
            path: {
                broker: data.broker
            },
            errors: {
                400: 'Cannot retrieve accounts from broker',
                404: 'Broker not found'
            }
        });
    }
    
    /**
     * Get broker assets
     * Retrieves all tradable assets available through the broker
     * @param data The data for the request.
     * @param data.broker Broker name
     * @returns AssetsResponseDto List of broker assets retrieved successfully
     * @throws ApiError
     */
    public static getBrokerAssets(data: GetBrokerAssetsData): CancelablePromise<GetBrokerAssetsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/broker/{broker}/assets',
            path: {
                broker: data.broker
            },
            errors: {
                404: 'Broker not found'
            }
        });
    }
    
    /**
     * Get asset options for broker by symbol
     * Retrieves all available options contracts for a specific asset symbol through the broker
     * @param data The data for the request.
     * @param data.broker Broker name
     * @param data.asset Asset symbol
     * @returns OptionsResponseDto Options for the asset retrieved successfully
     * @throws ApiError
     */
    public static getBrokerOptions(data: GetBrokerOptionsData): CancelablePromise<GetBrokerOptionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/broker/{broker}/assets/asset/{asset}/options',
            path: {
                broker: data.broker,
                asset: data.asset
            },
            errors: {
                404: 'Broker not found'
            }
        });
    }
    
    /**
     * Get options for broker by instrument code
     * Retrieves all available options contracts for a specific instrument code through the broker
     * @param data The data for the request.
     * @param data.broker Broker name
     * @param data.code Instrument code
     * @returns OptionsResponseDto Options for the instrument retrieved successfully
     * @throws ApiError
     */
    public static getBrokerOptionsByInstrument(data: GetBrokerOptionsByInstrumentData): CancelablePromise<GetBrokerOptionsByInstrumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/broker/{broker}/instruments/instrument/{code}/options',
            path: {
                broker: data.broker,
                code: data.code
            },
            errors: {
                404: 'Broker or instrument not found'
            }
        });
    }
    
    /**
     * Get broker positions
     * Retrieves all current positions held by the broker, enriched with the matching instrument and market when they can be resolved
     * @param data The data for the request.
     * @param data.broker Broker name
     * @returns BrokerPositionsResponseDto Broker positions retrieved successfully
     * @throws ApiError
     */
    public static getBrokerPositions(data: GetBrokerPositionsData): CancelablePromise<GetBrokerPositionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/broker/{broker}/positions',
            path: {
                broker: data.broker
            },
            errors: {
                404: 'Broker not found'
            }
        });
    }
    
    /**
     * Get price for action
     * Retrieves the current market price for a specific action/symbol in the given currency
     * @param data The data for the request.
     * @param data.broker Broker name
     * @param data.action Asset symbol or action
     * @param data.currency Currency code
     * @returns PriceResponseDto Current price retrieved successfully
     * @throws ApiError
     */
    public static getPrices(data: GetPricesData): CancelablePromise<GetPricesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/brokers/broker/{broker}/price/{action}/{currency}',
            path: {
                broker: data.broker,
                action: data.action,
                currency: data.currency
            },
            errors: {
                404: 'Broker not found'
            }
        });
    }
    
}

export class InstrumentsService {
    /**
     * List all instruments
     * Retrieves all available trading instruments with their market associations
     * @param data The data for the request.
     * @param data.type Filter instruments by type
     * @returns InstrumentsResponseDto Instruments retrieved successfully
     * @throws ApiError
     */
    public static listInstruments(data: ListInstrumentsData = {}): CancelablePromise<ListInstrumentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/instruments',
            query: {
                type: data.type
            }
        });
    }
    
    /**
     * Import instruments
     * Bulk imports instrument data
     * @param data The data for the request.
     * @param data.requestBody Instruments to import
     * @returns EmptyResponseDto Instruments imported successfully
     * @throws ApiError
     */
    public static importInstruments(data: ImportInstrumentsData): CancelablePromise<ImportInstrumentsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/instruments',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Add instrument
     * Adds a single instrument
     * @param data The data for the request.
     * @param data.requestBody Instrument to add
     * @returns EmptyResponseDto Instrument added successfully
     * @throws ApiError
     */
    public static addInstrument(data: AddInstrumentData): CancelablePromise<AddInstrumentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/instruments/instrument',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Find similar instruments
     * Scans the whole instruments table and returns groups of instruments that are probably duplicates created by different sources: instruments sharing an ISIN, a CIK, or having the same (or prefixed) name. Each group can then be reviewed and merged with the merge route
     * @returns SimilarInstrumentsResponseDto Groups of similar instruments retrieved successfully
     * @throws ApiError
     */
    public static findSimilarInstruments(): CancelablePromise<FindSimilarInstrumentsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/instruments/similar'
        });
    }
    
    /**
     * Merge an instrument into another
     * Merges a duplicated instrument (created by sources) into the one to keep: markets, valuations, incomes and shares counts are moved to the target (duplicated rows are merged), missing fields are copied, then the source instrument is deleted
     * @param data The data for the request.
     * @param data.requestBody Codes of the instruments to merge
     * @returns InstrumentResponseDto Instruments merged successfully, returns the merged instrument
     * @throws ApiError
     */
    public static mergeInstruments(data: MergeInstrumentsData): CancelablePromise<MergeInstrumentsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/instruments/merge',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Get instrument statistics
     * Retrieves statistical data for instruments
     * @returns InstrumentStatisticsDto Instrument statistics retrieved successfully
     * @throws ApiError
     */
    public static getInstrumentsStatistics(): CancelablePromise<GetInstrumentsStatisticsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/instruments/statistics'
        });
    }
    
    /**
     * Search instruments
     * Auto-detects ISIN, symbol, or name and returns matching instruments
     * @param data The data for the request.
     * @param data.q Search query (ISIN, symbol, or name)
     * @param data.limit Max results (default 20)
     * @returns InstrumentsResponseDto Instruments found
     * @throws ApiError
     */
    public static search(data: SearchData): CancelablePromise<SearchResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/instruments/search',
            query: {
                q: data.q,
                limit: data.limit
            }
        });
    }
    
    /**
     * Search for an instrument
     * Searches for a single instrument by ISIN, symbol, or name
     * @param data The data for the request.
     * @param data.name Instrument name
     * @param data.symbol Instrument symbol
     * @param data.isin ISIN code
     * @returns InstrumentResponseDto Instrument found
     * @throws ApiError
     */
    public static searchInstrument(data: SearchInstrumentData = {}): CancelablePromise<SearchInstrumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/instruments/search/one',
            query: {
                name: data.name,
                symbol: data.symbol,
                isin: data.isin
            }
        });
    }
    
    /**
     * Get instrument details
     * Retrieves detailed information for a specific instrument including markets, valuations, incomes, and share counts
     * @param data The data for the request.
     * @param data.code
     * @returns InstrumentResponseDto Instrument details retrieved successfully
     * @throws ApiError
     */
    public static getInstrument(data: GetInstrumentData): CancelablePromise<GetInstrumentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/instruments/intrument/{code}',
            path: {
                code: data.code
            }
        });
    }
    
}

export class MarketsService {
    /**
     * List all markets
     * Retrieves all available trading markets with instrument counts
     * @returns MarketsResponseDto Markets retrieved successfully
     * @throws ApiError
     */
    public static listMarkets(): CancelablePromise<ListMarketsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/markets'
        });
    }
    
    /**
     * Import markets
     * Bulk imports market data
     * @param data The data for the request.
     * @param data.requestBody Markets to import
     * @returns EmptyResponseDto Markets imported successfully
     * @throws ApiError
     */
    public static importMarkets(data: ImportMarketsData): CancelablePromise<ImportMarketsResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/markets',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Add market
     * Adds a single market
     * @param data The data for the request.
     * @param data.requestBody Market to add
     * @returns EmptyResponseDto Market added successfully
     * @throws ApiError
     */
    public static addMarket(data: AddMarketData): CancelablePromise<AddMarketResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/markets/market',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
}

export class SourcesService {
    /**
     * List all sources
     * Retrieves all available data sources with their capabilities
     * @returns SourcesResponseDto Data sources retrieved successfully
     * @throws ApiError
     */
    public static listSources(): CancelablePromise<ListSourcesResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sources'
        });
    }
    
    /**
     * Get price from source
     * Retrieves the current price for a ticker from a specific data source
     * @param data The data for the request.
     * @param data.source Source name
     * @param data.ticker Ticker symbol
     * @returns PriceResponseDto Current price retrieved successfully
     * @throws ApiError
     */
    public static getSourcePrice(data: GetSourcePriceData): CancelablePromise<GetSourcePriceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sources/source/{source}/ticker/{ticker}/price',
            path: {
                source: data.source,
                ticker: data.ticker
            },
            errors: {
                400: 'Source not found or cannot get price'
            }
        });
    }
    
    /**
     * Get option price from source
     * Retrieves the current price for an option contract from a specific data source
     * @param data The data for the request.
     * @param data.source Source name
     * @param data.symbol OCC option symbol
     * @returns PriceResponseDto Option price retrieved successfully
     * @throws ApiError
     */
    public static getOptionPrice(data: GetOptionPriceData): CancelablePromise<GetOptionPriceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/sources/source/{source}/option/{symbol}/price',
            path: {
                source: data.source,
                symbol: data.symbol
            },
            errors: {
                400: 'Source not found or cannot get option price'
            }
        });
    }
    
}

export class HealthService {
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static healthzLive(): CancelablePromise<HealthzLiveResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/healthz/live'
        });
    }
    
    /**
     * @returns unknown
     * @throws ApiError
     */
    public static healthzReady(): CancelablePromise<HealthzReadyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/healthz/ready'
        });
    }
    
}

export class BalancesService {
    /**
     * Get balance history
     * Retrieves historical balance data aggregated by specified time granularity
     * @param data The data for the request.
     * @param data.granularity Time granularity
     * @param data.broker Filter by broker name
     * @returns BalanceHistoryResponseDto Balance history retrieved successfully
     * @throws ApiError
     */
    public static getBalancesHistory(data: GetBalancesHistoryData): CancelablePromise<GetBalancesHistoryResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/balances/history',
            query: {
                granularity: data.granularity,
                broker: data.broker
            },
            errors: {
                401: 'Invalid granularity parameter'
            }
        });
    }
    
}

export class DecisionsService {
    /**
     * Get decisions
     * Retrieves trading decisions with optional filtering by trader and pagination
     * @param data The data for the request.
     * @param data.traderId Filter by trader ID
     * @param data.take Number of results to return
     * @param data.skip Number of results to skip
     * @returns DecisionsResponseDto Decisions retrieved successfully
     * @throws ApiError
     */
    public static getDecisions(data: GetDecisionsData = {}): CancelablePromise<GetDecisionsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/decisions',
            query: {
                traderId: data.traderId,
                take: data.take,
                skip: data.skip
            }
        });
    }
    
}

export class NotificationsService {
    /**
     * Add APNS token
     * Registers an Apple Push Notification Service token for receiving notifications
     * @param data The data for the request.
     * @param data.requestBody APNS token
     * @returns ApnsResponseDto Token added successfully
     * @throws ApiError
     */
    public static addApnsToken(data: AddApnsTokenData): CancelablePromise<AddApnsTokenResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/notifications/apns/token',
            body: data.requestBody,
            mediaType: 'application/json'
        });
    }
    
    /**
     * Test APNS notification
     * Sends a test push notification to registered APNS tokens
     * @returns ApnsResponseDto Test notification sent successfully
     * @throws ApiError
     */
    public static testNotificationApns(): CancelablePromise<TestNotificationApnsResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/v1/notifications/apns/test'
        });
    }
    
}

export class ScreenersService {
    /**
     * List all screeners
     * Retrieves a list of all available stock/option screeners with their parameters
     * @returns ScreenersResponseDto List of screeners retrieved successfully
     * @throws ApiError
     */
    public static listScreeners(): CancelablePromise<ListScreenersResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/screeners'
        });
    }
    
    /**
     * Create a new screening run
     * Creates and starts a new screening run. Returns a run ID that can be used to stream events.
     * @param data The data for the request.
     * @param data.requestBody Screening parameters
     * @returns ScreeningRunResponseDto Screening run created successfully
     * @throws ApiError
     */
    public static createOptionInterestScreeningRun(data: CreateOptionInterestScreeningRunData): CancelablePromise<CreateOptionInterestScreeningRunResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/v1/screeners/screener/optionInterest/runs',
            body: data.requestBody,
            mediaType: 'application/json',
            errors: {
                400: 'Invalid parameters',
                404: 'Screener or broker not found'
            }
        });
    }
    
    /**
     * Stream screening run events
     * Streams real-time events from a screening run as Server-Sent Events (SSE). Connect to this endpoint to receive live updates.
     * @param data The data for the request.
     * @param data.runId Screening run ID
     * @returns string Server-Sent Events stream of screener results
     * @throws ApiError
     */
    public static streamScreeningRun(data: StreamScreeningRunData): CancelablePromise<StreamScreeningRunResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/screeners/runs/run/{runId}/events',
            path: {
                runId: data.runId
            },
            errors: {
                404: 'Screening run not found'
            }
        });
    }
    
    /**
     * List all screening runs
     * Retrieves a list of all screening runs with their current status
     * @returns ScreeningRunStatusDto List of screening runs retrieved successfully
     * @throws ApiError
     */
    public static listRuns(): CancelablePromise<ListRunsResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/screeners/runs'
        });
    }
    
    /**
     * Get screening run status
     * Retrieves the current status and result of a screening run
     * @param data The data for the request.
     * @param data.runId Screening run ID
     * @returns ScreeningRunStatusDto Screening run status retrieved successfully
     * @throws ApiError
     */
    public static getRunStatus(data: GetRunStatusData): CancelablePromise<GetRunStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/v1/screeners/runs/run/{runId}',
            path: {
                runId: data.runId
            },
            errors: {
                404: 'Screening run not found'
            }
        });
    }
    
}